"use strict";

import Alpine from 'alpinejs';

/**
 * Init Alpine.js
 */
window.Alpine = Alpine;
Alpine.start();
